/**
 * Single source of truth for Launchpad launch fee + allocation.
 * Mirrors backend constants in server.py (LAUNCH_FEE_USD, FEE_SPLIT).
 * If backend ever changes, the UI hydrates via GET /api/launchpad/payments/config
 * so the numbers stay in sync — these defaults are only a fallback.
 */
export const LAUNCH_FEE_USD = 99;
export const ECOSYSTEM_PERCENT = 40;
export const BUY_BURN_PERCENT = 40;
export const OPERATIONS_PERCENT = 20;

export function computeAllocations(fee = LAUNCH_FEE_USD) {
  return {
    ecosystem:  Number((fee * ECOSYSTEM_PERCENT / 100).toFixed(2)),
    buyBurn:    Number((fee * BUY_BURN_PERCENT / 100).toFixed(2)),
    operations: Number((fee * OPERATIONS_PERCENT / 100).toFixed(2)),
  };
}

export const PAYMENT_MODES = Object.freeze({
  LOCALNET_TEST: "LOCALNET_TEST",
  DEVNET_TEST:   "DEVNET_TEST",
  MAINNET_LIVE:  "MAINNET_LIVE", // reserved — NOT enabled in current build
});

export const TEST_PAYMENT_MODES = Object.freeze([
  PAYMENT_MODES.LOCALNET_TEST,
  PAYMENT_MODES.DEVNET_TEST,
]);

export const LIVE_PAYMENT_MODES = Object.freeze([
  PAYMENT_MODES.MAINNET_LIVE,
]);

/**
 * Phase 7 — supported settlement currencies for LIVE mode.
 * The Launchpad flow itself is currency-agnostic; the payment service
 * picks the right on-chain transfer builder when LIVE_PAYMENTS_ENABLED
 * flips server-side.
 */
export const LAUNCH_CURRENCIES = Object.freeze({
  SOL:  "SOL",
  USDC: "USDC",
});

export function isLiveMode(mode) {
  return LIVE_PAYMENT_MODES.includes(String(mode || "").toUpperCase());
}

export function activePaymentMode(networkId) {
  const id = String(networkId || "").toUpperCase();
  if (id === "MAINNET")  return PAYMENT_MODES.MAINNET_LIVE;
  if (id === "DEVNET")   return PAYMENT_MODES.DEVNET_TEST;
  return PAYMENT_MODES.LOCALNET_TEST;
}
